<template>
  <div class="app-forgot-password-error">
    <slot name="txtError"></slot>
    <b-row class="app-stepper">
      <b-overlay class="btn-next-overlay">
        <button @click="back()" class="btn-prev text">
          <slot name="btnPrev">Zurück</slot>
        </button>
      </b-overlay>
    </b-row>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'ForgotPasswordInputError',
  methods: {
    ...mapMutations('forgotPassword', [
      'setView'
    ]),
    back () {
      this.setView('input')
    }
  }
}
</script>
